// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Q5Nl","footer":"ReportModalFilter_footer__AyAD1"};